import { takeLatest } from 'redux-saga/effects';
import { PUBLISH_OFFER } from '../../reducers';
import { publishOffer } from './publishOffer';

export function* publishInfoSagas() {
  yield takeLatest(PUBLISH_OFFER, publishOffer);
}
